module.exports = __webpack_public_path__ + "img/pro_one_7.e43b78e3.jpg";